import React from 'react';
export var Href = function (_a) {
    var href = _a.href, title = _a.title, className = _a.className, children = _a.children;
    return (React.createElement("a", { href: href, title: title, className: className, target: "_blank", rel: "nofollow noopener noreferrer" }, children));
};
//# sourceMappingURL=Href.js.map